import { request } from "@/utils/request";

const api = {
  dict: '/system/dict/',
  dictcontent: '/system/dictcontent/'
}

export function getDictList(params) {
  return request({
    url: api.dict + 'list',
    method: 'get',
    params
  })
}

export function saveDict(data) {
  return request({
    url: api.dict + 'save',
    method: 'post',
    data
  })
}

export function removeDict(ids) {
  return request({
    url: api.dict + 'remove',
    method: 'post',
    data: ids
  })
}

export function getDictContentList(params) {
  return request({
    url: api.dictcontent + 'list',
    method: 'get',
    params
  })
}

export function saveDictContent(data) {
  return request({
    url: api.dictcontent + 'save',
    method: 'post',
    data
  })
}

export function removeDictContent(ids) {
  return request({
    url: api.dictcontent + 'remove',
    method: 'post',
    data: ids
  })
}

export function downloadDictTemplate(params) {
  return request({
    url: api.dict + 'exporttemplate',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function importDictData(file, params) {
  const form = new FormData()
  form.append('file', file)
  params && Object.keys(params).forEach(k => {
    if (params[k] != null) {
      form.append(k, params[k])
    }
  })
  return request({
    url: api.dict + 'import',
    method: 'post',
    data: form
  })
}